import { Checkbox, FormControlLabel } from "@mui/material"
import type { ChangeEvent, FC } from "react"
import { useFieldArray } from "react-hook-form"

interface FilterCheckboxProps {
  control: any
  label: string
  name: string
  value: string
  values: string[]
  onFilterChange: (value: string[]) => void
  disabled?: boolean
  "data-testid"?: string
}

export const FilterCheckbox: FC<FilterCheckboxProps> = ({
  control,
  name,
  onFilterChange,
  values,
  label,
  value,
  disabled,
  "data-testid": testId,
}) => {
  const { fields, append, remove } = useFieldArray({ control, name })

  const isChecked = values.includes(value)

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    let updatedFilters = []
    if (e.target.checked) {
      append(value)
      updatedFilters = [...values, value]
    } else {
      const indexToRemove = fields.findIndex((field) => field.id === value)
      remove(indexToRemove)
      updatedFilters = values.filter((v) => v !== value)
    }

    onFilterChange(updatedFilters)
  }

  return (
    <FormControlLabel
      control={
        <Checkbox checked={isChecked} onChange={handleCheckboxChange} disabled={disabled} data-testid={testId} />
      }
      label={label}
      className={"w-full text-ellipsis"}
      disabled={disabled}
    />
  )
}
